

























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { StoreModel, Timing } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import {storeService} from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class SaveStoreTimingsPage extends Base {
  public storeViewModel: any = {};
  public storeModel: StoreModel = {};
  public requestProgress: boolean = false;
  public timingModel: Timing = {
    days: this.days,
    to: '',
    from: '',
    startTime: '00:00',
    endTime: '00:00',
  };
  get days(): string {
    if (this.timingModel) {
      return this.timingModel.from + '-' + this.timingModel.to;
    }
    return '';
  }
  set days(value) {
    this.timingModel.from = value.split('-')[0];
    this.timingModel.to = value.split('-')[1];
  }
  public form: any = {};
  public storeTimingFields: Array<VFields<any>> = [];
  public storeId: number = 0;
  public tenantId: number = 0;
  public enterpriseId: number = 0;

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'Timing' },
        })
        .catch(() => {
          // catch block
        });
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, this.$t('stores.timings.alertInvalidForm'));
        this.resetMethodName(methodName);
        return;
      }
      this.saveStoreTiming();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }

  public mounted() {
    this.setTimingFields();
    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
      this.getStoreInfo();
    }

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }
  public setTimingFields(): void {
    this.storeTimingFields = [
      {
        key: 'from',
        required: true,
        type: 'v-alynk-select',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t('stores.timings.timingFields.from') as string,
          items: [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
          ],
          altag: 'From',
          loading: false,
          rules:[
            v => this.required('From', v)
          ]
        },
      },
      {
        key: 'to',
        required: true,
        type: 'v-alynk-select',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t('stores.timings.timingFields.to') as string,
          items: [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
          ],
          altag: 'To',
          loading: false,
          rules:[
            v => this.required('To', v)
          ]
        },
      },

      {
        key: 'startTime',
        required: false,
        type: 'v-alynk-timepicker',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.timings.timingFields.startTime') as string,
          events: {
            onChange: (val) => {
              this.timingModel.startTime = this.$moment(val, 'HH:mm').format(
                'hh:mm A'
              );
            },
          },
          loading: false,
        },
      },
      {
        key: 'endTime',
        required: false,
        type: 'v-alynk-timepicker',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.timings.timingFields.endTime') as string,
          loading: false,
          events: {
            onChange: (val) => {
              this.timingModel.endTime = this.$moment(val, 'HH:mm').format(
                'hh:mm A'
              );
            },
          },
        },
      },
    ];
  }

  public validateStoreTiming(): Vue & { validate: () => boolean } {
    return this.$refs.storeTimingForm as Vue & { validate: () => boolean };
  }
  
  public async saveStoreTiming(): Promise<void> {
    if(this.validateStoreTiming().validate()){
      var validateRes = this.$validator.errors.items.length > 0;
        if(validateRes){
          this.showAlert(false, 'Please Enter Valid Details');
          return;
        }
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        this.timingModel.days = this.timingModel.from + '-' + this.timingModel.to;
        if (this.timingModel.id !== undefined) {
          await storeService.updateTiming(
            this.storeViewModel.id,
            this.timingModel
          );
          const existing = this.storeModel.timingJson.find((m) => {
            return m.id === this.timingModel.id;
          });
          if (existing) {
            existing.startTime = this.timingModel.startTime;
            existing.endTime = this.timingModel.endTime;
          } else {
            this.storeModel.timingJson.push(this.timingModel);
          }
          this.storeViewModel.timingJson = this.storeModel.timingJson;
          this.showAlert(true, this.$t('stores.timings.alertStoreTimingUpdated'));
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                tenantId: this.tenantId.toString(),
                enterpriseId: this.enterpriseId.toString(),
                storeId: this.storeId.toString(),
                tab:'Timing'
              },
            })
            .catch(() => {
              // catch block
            });
        } else {
          await storeService.saveTiming(
            this.storeViewModel.id,
            this.timingModel
          );
          const existing = this.storeModel.timingJson.find((m) => {
            return m.id === this.timingModel.id;
          });
          if (existing) {
            existing.startTime = this.timingModel.startTime;
            existing.endTime = this.timingModel.endTime;
          } else {
            this.storeModel.timingJson.push(this.timingModel);
          }
          this.storeViewModel.timingJson = this.storeModel.timingJson;
          this.showAlert(true, this.$t('stores.timings.alertStoreTimingSaved'));
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                tenantId: this.tenantId.toString(),
                enterpriseId: this.enterpriseId.toString(),
                storeId: this.storeId.toString(),
                tab:'Timing'
              },
            })
            .catch(() => {
              // catch block
            });
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }
  public async getStoreInfo(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.storeTimingFields);
      const response = await storeService.getStore(this.storeId);
      this.storeViewModel = response;
      this.setTiming();
      this.storeModel.id = this.storeViewModel.id;
      this.storeModel.timingJson = this.storeViewModel.timingJson || [];
    } finally {
      this.formlyHideSkeleton(this.storeTimingFields);
    }
  }
  public setTiming() {
    if (this.$route.params.timingId) {
      this.timingModel = this.storeViewModel.timingJson.find((m) => {
        return m.id === this.$route.params.timingId;
      }) || {
        startTime: '',
        endTime: '',
      };
      this.days = this.timingModel.days;
    }
  }
}
